module.exports = __webpack_public_path__ + "static/thumbtack.9cd0152f.jpg";